export const enum AssetLocation {OpenDAW, Local}